import {Box, Heading, Image, Skeleton, Text} from "grommet";
import React from "react";
import {PositionAbsoluteBox, PositionRelativeBox} from "../../../utils/styled";
import {
    faEllipsisStrokeVertical as IconDotsVertical
} from '@fortawesome/pro-light-svg-icons';
import FontAwesomeIcon from "../../FontAwesomeIcon";
import { snakeCase } from "../../../utils/string";
import Menu from "../../Menu";
// Style wrapper for the connections in settings/connection
const ConnectionCard = ({
    logoSrc,
    isLoaded,
    connectionName,
    menuItems,
    children,
    nested,
    details,
    cta,
    logoContainerProps={},
    ...rest
}) => {
    return (
        <Box
            border={true}
            round="xsmall"
            justify="between"
            direction="column"
            background="foreground"
            height={{min: 'small'}}
            {...rest}>
            <PositionRelativeBox pad="medium" gap="small">
                <Box
                    align="start"
                    height={'xxsmall'}
                    width={'xxsmall'}
                    {...logoContainerProps}>
                    <Image
                        src={logoSrc}
                        fit="contain"
                        alt={`${connectionName} logo`}
                    />
                </Box>
                <Heading level={3} margin={{top: 'xxsmall', bottom: 'small'}}>{connectionName}</Heading>
                {isLoaded ? children : (
                    <Box height={{min: "100px"}} gap="xsmall">
                        <Skeleton width="small" />
                        <Skeleton width="xsmall" />
                    </Box>
                )}
                {details && (Array.isArray(details) ? details.length > 0 : true) && (
                    <Box gap="xsmall">
                        {Array.isArray(details)
                            ? details.map((item, index) =>
                                typeof item === 'string' ? (
                                    <Text key={index} color="text-weak" size="small">{item}</Text>
                                ) : (
                                    React.cloneElement(item, { key: index })
                                )
                            )
                            : typeof details === 'string'
                                ? <Text color="text-weak" size="small">{details}</Text>
                                : details}
                    </Box>
                )}
                {cta && (
                    <Box margin={{top: 'small'}} fill="horizontal">
                        {cta}
                    </Box>
                )}
                {menuItems &&
                    (<PositionAbsoluteBox top="0" right="0" pad="small">
                        <Menu
                            nested={nested}
                            event={{section: `${snakeCase(connectionName)}_connection_card`, element: 'menu'}}
                            responsive={false}
                            dropProps={{
                                align: { top: 'bottom', right: 'right' },
                                margin: { vertical: 'xsmall', horizontal: 'xxsmall' },
                                border: true
                            }}
                            icon={(
                                <Box responsive={false} align="center" width="20px">
                                    <FontAwesomeIcon SelectedIcon={IconDotsVertical} size="small" />
                                </Box>
                            )}
                            items={menuItems}
                        />
                    </PositionAbsoluteBox>)
                }
            </PositionRelativeBox>
        </Box>
    );
}

export default ConnectionCard;
